module.exports = __webpack_public_path__ + "static/media/Apple Lady.8965ecd8.png";